'use strict';
(function () {
  /* ── Internal state ─────────────────────────────────────────────────── */
  var _canvas    = null;
  var _ctx       = null;
  var _baseSrc   = null;
  var _artworkUrl = null;
  var _location  = null;
  var _sizeKey   = null;

  /* Artwork position (0–1 fractions of canvas dimensions, centre-point) */
  var _artX    = 0.5;
  var _artY    = 0.35;
  var _artScale = 1.0;   // multiplied on top of the preset w/h

  /* Preset position restored by Reset button */
  var _presetX = 0.5;
  var _presetY = 0.35;

  /* Drag state */
  var _dragging   = false;
  var _dragOffX   = 0;
  var _dragOffY   = 0;

  /* Cached loaded images (avoid re-fetching on every mousemove) */
  var _baseImg    = null;
  var _artworkImg = null;
  var _baseLoaded = false;
  var _artLoaded  = false;

  /* Snap threshold (fraction of canvas width) */
  var SNAP_THRESHOLD = 0.05;

  /* ── Centre of artwork bounding box (for hit-test) ─────────────────── */
  function _artworkRect() {
    if (!_canvas || !_artworkImg || !_location) return null;
    var pos  = (window.CUSTOMIZER_POSITIONS || {})[_location];
    var mult = ((window.CUSTOMIZER_SIZE_MULTIPLIERS || {})[_sizeKey] || 1.0) * _artScale;
    if (!pos) return null;
    var W = _canvas.width;
    var H = _canvas.height;
    var aw = pos.w * mult * W;
    var ah = (_artworkImg.height / _artworkImg.width) * aw;
    var ax = _artX * W - aw / 2;
    var ay = _artY * H - ah / 2;
    return { x: ax, y: ay, w: aw, h: ah };
  }

  /* ── Draw everything ────────────────────────────────────────────────── */
  function _draw(showGuides) {
    if (!_canvas || !_ctx) return;
    var W = _canvas.width;
    var H = _canvas.height;
    _ctx.clearRect(0, 0, W, H);

    /* Base product image */
    if (_baseLoaded && _baseImg) {
      _ctx.drawImage(_baseImg, 0, 0, W, H);
    }

    /* Artwork overlay */
    if (_artLoaded && _artworkImg && _location) {
      var r = _artworkRect();
      if (r) {
        _ctx.save();
        _ctx.globalAlpha = 0.85;
        _ctx.drawImage(_artworkImg, r.x, r.y, r.w, r.h);
        _ctx.restore();
      }
    }

    /* Alignment guides — dashed crosshairs while dragging */
    if (showGuides && _dragging) {
      _ctx.save();
      _ctx.strokeStyle = 'rgba(232,246,14,0.55)';
      _ctx.lineWidth   = 1;
      _ctx.setLineDash([4, 4]);
      /* Vertical centre */
      _ctx.beginPath(); _ctx.moveTo(W / 2, 0); _ctx.lineTo(W / 2, H); _ctx.stroke();
      /* Horizontal centre */
      _ctx.beginPath(); _ctx.moveTo(0, H / 2); _ctx.lineTo(W, H / 2); _ctx.stroke();
      _ctx.restore();
    }
  }

  /* ── Load base image, then render ──────────────────────────────────── */
  function _loadBase() {
    if (!_baseSrc) return;
    _baseLoaded = false;
    var img = new Image();
    // crossOrigin MUST be set before .src — otherwise the browser ignores it.
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      _baseImg    = img;
      _baseLoaded = true;
      _draw();
    };
    img.onerror = function () {
      // If the CDN doesn't send CORS headers the load fails here.
      // canvas.toDataURL() will still work — no base image means no taint.
      console.warn('[CustPreview] base image failed to load (CORS or network):', _baseSrc);
      _ctx && _ctx.clearRect(0, 0, _canvas.width, _canvas.height);
    };
    // Append a cache-bust param so the browser issues a fresh CORS-mode request
    // instead of reusing a stale non-CORS cache entry (which would taint the canvas
    // and make toDataURL() throw a SecurityError).
    var sep = _baseSrc.indexOf('?') === -1 ? '?' : '&';
    img.src = _baseSrc + sep + '_c=1';
  }

  /* ── Load artwork image, then render ───────────────────────────────── */
  function _loadArtwork() {
    if (!_artworkUrl) { _artLoaded = false; _artworkImg = null; _draw(); return; }
    _artLoaded = false;
    var img = new Image();
    // anonymous crossOrigin lets toDataURL() work without tainting the canvas
    // when the artwork is served from a CDN with CORS headers.
    // blob: URLs are same-origin so this attribute is silently ignored for them.
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      _artworkImg = img;
      _artLoaded  = true;
      _draw();
    };
    img.src = _artworkUrl;
  }

  /* ── Convert pointer event → canvas-fraction coords ────────────────── */
  function _eventToFrac(e) {
    var rect = _canvas.getBoundingClientRect();
    var cx = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    var cy = e.clientY !== undefined ? e.clientY : e.touches[0].clientY;
    return {
      x: (cx - rect.left)  / rect.width,
      y: (cy - rect.top)   / rect.height,
    };
  }

  /* ── Hit-test: is fractional point (fx, fy) inside the artwork? ─────── */
  function _hitArtwork(fx, fy) {
    if (!_artLoaded || !_artworkImg || !_location || !_canvas) return false;
    var W = _canvas.width;
    var H = _canvas.height;
    var r = _artworkRect();
    if (!r) return false;
    var px = fx * W;
    var py = fy * H;
    /* Expand hit area by 12px each side for easier touch targeting */
    var pad = 12;
    return px >= r.x - pad && px <= r.x + r.w + pad &&
           py >= r.y - pad && py <= r.y + r.h + pad;
  }

  /* ── Snap to centre helpers ─────────────────────────────────────────── */
  function _snap(v, target) {
    return Math.abs(v - target) < SNAP_THRESHOLD ? target : v;
  }

  /* ── Pointer down ───────────────────────────────────────────────────── */
  function _onDown(e) {
    if (!_artLoaded) return;
    var f = _eventToFrac(e);
    if (_hitArtwork(f.x, f.y)) {
      _dragging  = true;
      _dragOffX  = f.x - _artX;
      _dragOffY  = f.y - _artY;
      _canvas.style.cursor = 'grabbing';
      e.preventDefault();
    }
  }

  /* ── Pointer move ───────────────────────────────────────────────────── */
  function _onMove(e) {
    if (!_dragging) {
      /* Update hover cursor */
      if (_artLoaded) {
        var f = _eventToFrac(e);
        _canvas.style.cursor = _hitArtwork(f.x, f.y) ? 'grab' : 'default';
      }
      return;
    }
    e.preventDefault();
    var f = _eventToFrac(e);
    var nx = Math.max(0.05, Math.min(0.95, f.x - _dragOffX));
    var ny = Math.max(0.05, Math.min(0.95, f.y - _dragOffY));
    /* Snap to centre */
    _artX = _snap(nx, 0.5);
    _artY = _snap(ny, 0.5);
    _draw(true);
  }

  /* ── Pointer up ─────────────────────────────────────────────────────── */
  function _onUp() {
    if (!_dragging) return;
    _dragging = false;
    _canvas.style.cursor = 'grab';
    _draw(false);
    /* Notify customizer.js so it can read final position */
    if (typeof _onPositionChange === 'function') _onPositionChange();
  }

  /* Optional callback set by customizer.js */
  var _onPositionChange = null;

  /* ── Attach drag listeners to a canvas element ─────────────────────── */
  function _attachDrag(el) {
    el.addEventListener('mousedown',  _onDown,  { passive: false });
    el.addEventListener('mousemove',  _onMove,  { passive: false });
    el.addEventListener('mouseup',    _onUp);
    el.addEventListener('mouseleave', _onUp);
    el.addEventListener('touchstart', _onDown,  { passive: false });
    el.addEventListener('touchmove',  _onMove,  { passive: false });
    el.addEventListener('touchend',   _onUp);
  }

  /* ── Recompute preset centre from location + size ───────────────────── */
  function _refreshPreset() {
    var pos = (window.CUSTOMIZER_POSITIONS || {})[_location];
    if (!pos) return;
    /* Preset centre = top-left anchor + half the preset box */
    _presetX = pos.x + pos.w / 2;
    _presetY = pos.y + pos.h / 2;
  }

  /* ── Public API (window.CustPreview) ─────────────────────────────────── */
  window.CustPreview = {

    init: function (canvasEl) {
      _canvas = canvasEl;
      _ctx    = canvasEl.getContext('2d');
      var size = canvasEl.offsetWidth || 400;
      _canvas.width  = size;
      _canvas.height = size;
      _attachDrag(canvasEl);
      canvasEl.style.cursor = 'default';
    },

    setBase: function (src) {
      _baseSrc = src;
      _loadBase();
    },

    setArtwork: function (url) {
      _artworkUrl = url;
      _loadArtwork();
    },

    setLocation: function (loc) {
      _location = loc;
      _refreshPreset();
      /* Reset to preset position whenever location changes */
      _artX = _presetX;
      _artY = _presetY;
      _draw();
    },

    setSize: function (sz) {
      _sizeKey = sz;
      _draw();
    },

    clear: function () {
      _artworkUrl = null;
      _artworkImg = null;
      _artLoaded  = false;
      _draw();
    },

    resetPosition: function () {
      _refreshPreset();
      _artX = _presetX;
      _artY = _presetY;
      _draw();
    },

    /** Returns current { x, y, scale } for cart line item properties */
    getPosition: function () {
      return {
        x:     _artX.toFixed(3),
        y:     _artY.toFixed(3),
        scale: _artScale.toFixed(3),
      };
    },

    /** Register a callback fired whenever the user finishes a drag */
    onPositionChange: function (fn) {
      _onPositionChange = fn;
    },
  };
})();
